var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import RowStyle from './RowStyle';
const Row = (_a) => {
    var { children, debug } = _a, props = __rest(_a, ["children", "debug"]);
    return (React.createElement(RowStyle, Object.assign({}, props, { debug: debug }),
        debug && (React.createElement("span", { className: "layout-label" },
            React.createElement("span", null))),
        children));
};
Row.defaultProps = {
    debug: false,
    debugColor: 'rgba(51,102,153,0.75)',
    hasMargin: true,
};
export default Row;
//# sourceMappingURL=Row.js.map